import {ModuleWithProviders, NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NuevaBancaLibraryComponent} from './nueva-banca-library.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateLibModule} from "./modules/translate/translate-lib.module";
import {CommonModule, DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {AvailabilityModalComponent} from './components/availability-modal/availability-modal.component';
import {AvailabilityOffModalComponent} from './components/availability-off-modal/availability-off-modal.component';
import {InternationalPaymentComponent} from './components/international-payment/international-payment.component';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {SkeletonModule} from 'primeng/skeleton';
import {CalendarModule} from "primeng/calendar";
import {AutoCompleteModule} from "primeng/autocomplete";
import {DropdownModule} from 'primeng/dropdown';
import {OperationSummaryComponent} from './components/international-operation-summary/operation-summary.component';
import {
  InternationalPaymentSuccessComponent
} from './components/payments/international-payment-success/international-payment-success.component';
import {SistemaAutenticacionComponent} from "./components/sistema-autenticacion/sistema-autenticacion.component";
import {SystemAuthenticationService} from "./services/sistema-autenticacion/system-authentication.service";
import {SchedulePaymentButtonComponent} from './components/schedule-payment-button/schedule-payment-button.component';
import {CustomSwitchComponent} from "./components/custom-switch/custom-switch.component";
import {PaymentSuccessComponent} from "./components/payments/payment-success/payment-success.component";
import {UtilsService} from './services/utils/utils.service';
import { ContractService } from './services/contracts/contract.service';
import {BulkPermissionsService} from "./services/bulk/bulk-permissions.service";
import {HasBulkPermissionByContractDirective} from "./directives/has-bulk-permission-by-contract.directive";
import { ItemsTableListComponent } from './components/items-table-list/items-table-list.component';
import {
  HasAddInternationalReceiverPermissionByContractDirective
} from "./directives/has-add-international-receiver-permission.directive";
import {
  PermissionInternationalReceiversService
} from "./services/permissions/permission-international-receivers.service";
import {PaginatorModule} from "primeng/paginator";
import {SharedModule} from "primeng/api";
import {TableModule} from "primeng/table";
import {CurrencyPipeModule} from "./pipes/currency-pipe.module";
import {PermissionMancomunadosPaymentsService} from "./services/permissions/permission-mancomunados-payments.service";


@NgModule({
  declarations: [
    NuevaBancaLibraryComponent,
    AvailabilityModalComponent,
    AvailabilityOffModalComponent,
    InternationalPaymentComponent,
    OperationSummaryComponent,
    InternationalPaymentSuccessComponent,
    SistemaAutenticacionComponent,
    SchedulePaymentButtonComponent,
    CustomSwitchComponent,
    PaymentSuccessComponent,
    HasBulkPermissionByContractDirective,
    ItemsTableListComponent,
    HasAddInternationalReceiverPermissionByContractDirective,

  ],
    imports: [
        FormsModule,
        TranslateLibModule,
        CommonModule,
        ProgressSpinnerModule,
        ReactiveFormsModule,
        SkeletonModule,
        CalendarModule,
        AutoCompleteModule,
        DropdownModule,
        NgbModule,
        CurrencyPipeModule,
        DecimalPipe,
        NgForOf,
        NgIf,
        PaginatorModule,
        SharedModule,
        SkeletonModule,
        TableModule,

    ],
  exports: [
    NuevaBancaLibraryComponent,
    TranslateLibModule,
    InternationalPaymentComponent,
    SistemaAutenticacionComponent,
    SchedulePaymentButtonComponent,
    CustomSwitchComponent,
    PaymentSuccessComponent,
    InternationalPaymentSuccessComponent,
    HasBulkPermissionByContractDirective,
    ItemsTableListComponent,
    HasAddInternationalReceiverPermissionByContractDirective
  ],
  providers: [
    SystemAuthenticationService,
    UtilsService,
    ContractService,
    BulkPermissionsService,
    PermissionInternationalReceiversService,
    PermissionMancomunadosPaymentsService
  ]
})


export class NuevaBancaLibraryModule {

  public static forRoot(environment: any): ModuleWithProviders<NuevaBancaLibraryModule> {

    return {
      ngModule: NuevaBancaLibraryModule,
      providers: [
        {
          provide: 'environment', // you can also use InjectionToken
          useValue: environment
        },

      ]
    };
  }

}
